import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';

import { APIComponent } from '../../../shared/api.component';
import { BaseLoopBackStorageService } from '../../../services/storage/loopback/base.service';
import { SettingLoopBackApiService } from '../../../services/api/loopback/custom/setting.service';

@Component({
  selector: 'drx-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.scss']
})
export class AdminSettingComponent extends APIComponent implements OnInit {

  public title = 'Setting';
  public path = 'admin/setting';

  public constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected formBuilder: FormBuilder,
    protected storageService: BaseLoopBackStorageService,
    protected apiService: SettingLoopBackApiService,
  ) {
    super(route, router, formBuilder, storageService, apiService);
  }

  public ngOnInit(): void {
    super.ngOnInit();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/setting/setting.component.ts